@if (filteredNotifications.length) {
<li class="h-[350px] overflow-y-auto ">
  @for (n of filteredNotifications; track n.id) {

  <div class="text-primary border-b border-[#E1E4EA] dark:border-[#1b2e4b]">
    <div class="group flex items-center gap-3 px-4 py-3 hover:bg-gray-50 dark:bg-[#0e1726]">
        <div class="flex-none">
            <div
                class="grid h-8 w-8 place-content-center rounded-full text-secondary border border-[#E1E4EA] dark:border-[#1b2e4b] bg-[#F5F7FA] dark:bg-[#1E293B]"
            >
                <ng-container *ngComponentOutlet="n.iconCmp"></ng-container>
            </div>
        </div>
        <div class="flex-1 cursor-pointer" (click)="handleNotificationClick(n)">
            @let isKyc = isVendorKycAlertFamily(n.alert_type);
            @let contractId = isContractAlertFamily(n.alert_type) ? mergeAlertMeta(n)['contract_id'] : null;
            <div class="flex-1">
                <div class="flex items-start justify-between">
                    <h6 class="font-semibold text-[#0E121B] dark:text-white">
                        @if (contractId) {
                        #{{ contractId }} {{ formatTitle(n.alert_type) }}
                        } @else {
                        {{ formatTitle(n.alert_type) }}
                        }
                    </h6>
                    <span class="mt-1 h-2.5 w-2.5 rounded-full" [ngClass]="n.read ? 'bg-success' : 'bg-red-600'"></span>
                </div>
                @if (!isKyc && n?.message) {
                <div class="text-xs text-[#64748B] dark:text-white/60">{{ plainNotificationMessage(n?.message) }}</div>
                }
                @if (n?.title) {
                <div class="text-xs font-medium text-gray-600 dark:text-white/60">{{ n?.title }}</div>
                }
                @if (n?.created_at) {
                <div class="text-xs text-[#3c3d3d] dark:text-white/60">
                    @if (isContractAlertFamily(n.alert_type)) {
                    {{ n.created_at | appContractVendorDate }}
                    } @else {
                    {{ timeAgo(n?.created_at || '') }}
                    }
                </div>
                }
            </div>
        </div>
    </div>
  </div>
} 
</li>
<li>
    <div class="px-4 py-2 flex justify-center">
        <app-button-fill title="Read All Notifications" type="button" (click)="navigateToNotificationList()"> </app-button-fill>
    </div>
</li>
} @else {
<li>
    <div class="!grid max-h-[200px] place-content-center text-lg hover:!bg-transparent">
        <div class="mx-auto mb-4 rounded-full text-primary ring-4 ring-primary/30">
            <svg width="40" height="40" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    opacity="0.5"
                    d="M20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10Z"
                    fill="currentColor"
                ></path>
                <path
                    d="M10 4.25C10.4142 4.25 10.75 4.58579 10.75 5V11C10.75 11.4142 10.4142 11.75 10 11.75C9.58579 11.75 9.25 11.4142 9.25 11V5C9.25 4.58579 9.58579 4.25 10 4.25Z"
                    fill="currentColor"
                ></path>
                <path
                    d="M10 15C10.5523 15 11 14.5523 11 14C11 13.4477 10.5523 13 10 13C9.44772 13 9 13.4477 9 14C9 14.5523 9.44772 15 10 15Z"
                    fill="currentColor"
                ></path>
            </svg>
        </div>
        No notifications available.
    </div>
</li>
}

@if (viewNotificationModel()) {
  <app-modal 
    title="Notification" 
    (close)="closeViewNotificationModal()" 
    [showFooter]="false"
  >
    <div class="w-full max-w-auto sm:max-w-[500px] lg:max-w-[600px] p-4 modal-content">
      @let d = isReadableNotificationDetails();
      @let merged = mergeNotificationDetail(d);
      <div class="">
        
        <!-- Notification Type Tag -->
        <div class="">
          <span
            class="inline-block px-3 py-1 rounded-md text-xs font-semibold"
            [ngClass]="notificationBadgeTailwind(d?.alert_type)"
          >
            {{ formatTitle(d?.alert_type) }}
          </span>
        </div>
        
        <!-- Message -->
         <div class="py-2 border-b border-gray-200 dark:border-gray-700 pb-2 mb-2"
        [ngClass]="{'border-b': d?.alert_type !== 'VENDOR_KYC'}"
        >
          @if (messageUsesSanitizedHtml(d?.alert_type, d?.message)) {
               <p class="text-secondary text-xs" [innerHTML]="sanitizeHtml(d?.message)"></p>
           }
           @else {
             <p class="text-secondary text-xs">
               {{ d?.message }}
             </p>
           }
         </div>
         

        <!-- VENDOR_KYC -->
        <!-- TENANT_INVITATION -->
        @if (d?.alert_type === 'TENANT_INVITATION') {
          <div class="space-y-2 text-xs text-secondary">
            <app-notification-meta-rows [rows]="tenantInvitationMetaRows(d)"></app-notification-meta-rows>
          </div>
        }
        <!-- Event / bid meta (any alert type when API sends these fields) -->
        @if (hasEventMeta(merged)) {
          <div class="space-y-2 text-xs text-secondary">
            <app-notification-meta-rows [meta]="merged" [fields]="eventDetailMetaFields"></app-notification-meta-rows>
            @if (genericMetaDisplayRows(merged, 15, d?.alert_type).length) {
            <app-notification-meta-rows [rows]="genericRowsAsStructured(genericMetaDisplayRows(merged, 15, d?.alert_type))"></app-notification-meta-rows>
            }
          </div>
        }

        <!-- CONTRACT family -->
        @if (isContractAlertFamily(d?.alert_type)) {
          <div class="space-y-2 text-xs text-secondary">
            <app-notification-meta-rows [meta]="merged" [fields]="contractDetailMetaFields" [useContractDate]="true"></app-notification-meta-rows>
          </div>
        }

        <!-- GENERAL / CHAT -->
        @if (d?.alert_type === 'GENERAL' || d?.alert_type === 'CHAT') {
          <div class="space-y-2 text-xs text-secondary">
            <app-notification-meta-rows [meta]="merged" [fields]="chatDetailMetaFields"></app-notification-meta-rows>
          </div>
        }
        @if (isPurchaseOrderFamily(d?.alert_type)) {
          <div class="space-y-2 text-xs text-secondary">
            <app-notification-meta-rows [meta]="merged" [fields]="purchaseOrderDetailMetaFields"></app-notification-meta-rows>
          </div>
        }
     <!-- Read/Unread -->
        <div class="flex items-center text-xs mt-4 text-gray-600 dark:text-[#ffffffcc] border-t border-gray-200 dark:border-secondary pt-4">
          <span 
            class="inline-block w-2 h-2 rounded-full" 
            [ngClass]="d?.is_read ? 'bg-[#1FC16B]' : 'bg-[#FB3748]'"
          ></span>
          <span class="ml-1">{{ d?.is_read ? 'Read' : 'Unread' }}</span>
          <span class="pl-4">
            @if (isContractAlertFamily(d?.alert_type)) {
            {{ d?.created_at | appContractVendorDate }}
            } @else {
            {{ getTimeAgo(d?.created_at) }}
            }
          </span>
        </div>

      </div>
    </div>
  </app-modal>
}
